var _polygon, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVodafone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "205px",
    height: "129px",
    viewBox: "0 0 205 129",
    enableBackground: "new 0 0 205 129",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    points: "27.021,98.637 21.962,113.326 16.786,98.637  10.401,98.637 18.293,120.115 25.303,120.115 33.24,98.637 27.021,98.637 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M65.651,109.402c0-3.203,2.6-5.803,5.804-5.803 c3.205,0,5.804,2.6,5.804,5.803c0,3.205-2.599,5.805-5.804,5.805C68.251,115.207,65.651,112.607,65.651,109.402L65.651,109.402z  M77.016,89.879v10.545c-0.012-0.006-0.02-0.014-0.028-0.021c-1.765-1.303-3.922-2.115-6.257-2.115 c-5.937,0-10.749,4.961-10.749,11.078s4.813,11.076,10.749,11.076c2.349,0,4.52-0.773,6.285-2.09v1.793h5.521V89.879H77.016 L77.016,89.879z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M91.907,109.402c0-3.203,2.6-5.803,5.802-5.803 c3.207,0,5.806,2.6,5.806,5.803c0,3.205-2.599,5.805-5.806,5.805C94.507,115.207,91.907,112.607,91.907,109.402L91.907,109.402z  M103.27,98.662v1.762c-0.008-0.006-0.018-0.014-0.028-0.021c-1.76-1.303-3.922-2.115-6.257-2.115 c-5.937,0-10.749,4.961-10.749,11.078s4.813,11.076,10.749,11.076c2.349,0,4.518-0.773,6.285-2.09v1.793h5.521V98.662H103.27 L103.27,98.662z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M123.836,98.662h-3.307c0,0-0.012-0.689-0.012-1.307 c0-1.361,0-3.09,2.168-3.09c0.557,0,1.092,0.094,1.092,0.094v-4.996c0,0-0.906-0.023-1.523,0c-5.076,0.197-7.311,1.93-7.311,7.004 v2.295h-2.471v4.949h2.471v16.5h5.586v-16.5h3.307V98.662L123.836,98.662z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M157.25,100.531c1.568-1.428,3.857-2.318,6.314-2.318 c5.061,0,7.959,3.223,7.973,7.479l0.002,2.406v12.018h-5.697v-11.486v-1.051c0-3.156-2.199-4.117-3.938-4.117 c-1.604,0-4.664,0.883-4.492,4.736v1.422v10.496h-5.707V98.66h5.545V100.531L157.25,100.531z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M181.17,111.068c0.271,2.697,2.527,4.664,5.291,4.664 c2.18,0,3.625-0.861,4.482-2.426h5.965c-0.955,3.344-4.715,7.125-10.256,7.125c-6.668,0-11.367-4.965-11.367-11.09 s5.037-11.092,11.367-11.092c6.332,0,10.836,5.398,10.836,11.092c0,1.186-0.133,1.719-0.133,1.719L181.17,111.068L181.17,111.068z  M191.469,106.918c-0.484-2.436-2.525-3.838-5.008-3.838c-2.563,0-4.568,1.492-5.143,3.822L191.469,106.918L191.469,106.918z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M49.538,98.965c-2.039,0.445-3.577,2.262-3.577,4.434 c0,0.047,0.012,0.104,0.013,0.15c3.226,0.686,4.853,2.861,4.853,5.727c0,3.223-2.635,5.836-5.856,5.836s-6.232-2.688-6.232-6.672 c0-4.867,4.172-9.434,10.116-9.576c0.106-0.002,0.275,0.002,0.448,0.01c-1.305-0.498-2.729-0.771-4.217-0.771 c-6.378,0-11.548,5.004-11.548,11.174c0,6.172,5.17,11.174,11.548,11.174c6.379,0,11.549-5.002,11.549-11.174 C56.634,104.633,53.706,100.652,49.538,98.965L49.538,98.965z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M136.629,98.195c-6.379,0-11.551,5.002-11.551,11.174 c0,4.643,2.93,8.625,7.1,10.311c2.039-0.447,3.574-2.26,3.574-4.434c0-0.047-0.012-0.102-0.014-0.148 c-3.225-0.686-4.852-2.861-4.852-5.729c0-3.223,2.635-5.834,5.857-5.834s6.232,2.686,6.232,6.672c0,4.867-4.172,9.43-10.117,9.576 c-0.105,0.002-0.275-0.004-0.447-0.012c1.305,0.498,2.727,0.771,4.217,0.771c6.377,0,11.547-5.004,11.547-11.174 C148.176,103.197,143.006,98.195,136.629,98.195L136.629,98.195z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M117.896,9.499c-6.492,1.429-11.383,7.25-11.383,14.219 c0,0.15,0.035,0.326,0.041,0.477c10.266,2.2,15.443,9.168,15.443,18.365c0,10.328-8.385,18.705-18.637,18.705 c-10.251,0-19.828-8.618-19.828-21.396c0-15.601,13.271-30.233,32.182-30.697c0.342-0.008,0.881,0.005,1.434,0.03 c-4.156-1.591-8.684-2.464-13.416-2.464c-20.295,0-36.749,16.038-36.749,35.822s16.454,35.822,36.749,35.822 c20.289,0,36.742-16.038,36.742-35.822C140.475,27.67,131.156,14.903,117.896,9.499L117.896,9.499z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVodafone);
export default __webpack_public_path__ + "static/media/vodafone.66f0cf6e173512663f9b23626c668e00.svg";
export { ForwardRef as ReactComponent };